<template>
  <div class="skeleton-card">
    <div class="container">
      <div class="list">
        <SkeletonItem
          v-for="i in 4"
          :key="i"
          class="skeleton-line"
        />
      </div>
      <SkeletonItem class="skeleton-img" />
    </div>

    <div class="subcontainer">
      <SkeletonItem
        v-for="i in 2"
        :key="i"
        class="skeleton-btn"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { SkeletonItem } from '@experience/core-skeleton-lib';
</script>

<style lang="scss" scoped>
  .container {
    display: flex;
    justify-content: space-between;
  }

  .list,
  .subcontainer {
    position: relative;
    width: 100%;
  }

  .skeleton-line {
    height: 20px;
    margin-top: 4px;
    border-radius: 16px;

    &:nth-child(1) {
      width: 60%;
      height: 20px;
      margin-top: 0;
    }

    &:nth-child(2) {
      width: 65%;
      height: 20px;
    }

    &:nth-child(3) {
      width: 60%;
      height: 20px;
    }

    &:nth-child(4) {
      width: 30%;
      height: 20px;
    }
  }

  .skeleton-img {
    width: 100%;
    max-width: 72px;
    height: 96px;
    border-radius: 16px;
  }

  .skeleton-btn {
    height: 14px;
    margin-top: 8px;
    border-radius: 16px;

    &:nth-child(1) {
      width: 80%;
    }

    &:nth-child(2) {
      width: 60%;
    }
  }
</style>
